import React from "react";
import { useLocation } from "react-router-dom";
import HeroD from "./HeroD";
import HeroE from "./HeroE";
import HeroF from "./HeroF";

/**
 * Editorial Corporate hero variants — switch via ?hero=d/e/f.
 *   - ?hero=d (default) → photo-right / text-left split
 *   - ?hero=e           → photo-left / text-right (mirrored, with stat overlay)
 *   - ?hero=f           → centered statement + 6-cell capability grid
 */
export default function HeroSwitch() {
  const { search } = useLocation();
  const variant = new URLSearchParams(search).get("hero")?.toLowerCase();
  if (variant === "f") return <HeroF />;
  if (variant === "e") return <HeroE />;
  return <HeroD />;
}
